import Typography from '@mui/material/Typography';
import { useState } from 'react';

import { Button } from '@/components/ui/Button';
import { LiveRegion } from '@/components/ui/LiveRegion';

import { State } from '../State';

export function LiveRegionExamples() {
  const [count, setCount] = useState(0);

  return (
    <State
      title="An announcement with no visible change"
      note="Invisible on the page; a screen reader hears each press. The line below only mirrors it."
    >
      <Button variant="secondary" size="sm" onClick={() => setCount((n) => n + 1)}>
        Move the item up
      </Button>
      <LiveRegion message={count ? `Moved to position ${count}` : ''} />
      <Typography variant="body2" color="text.secondary" aria-hidden>
        {count ? `Announced: "Moved to position ${count}"` : 'Nothing announced yet.'}
      </Typography>
    </State>
  );
}
